import React, { useEffect } from "react";
import Header from "./header/Header";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, NavLink } from "react-router-dom";
import Footer from "./common/Footer";
import Effects from "./common/Effects";
import PeopleDesc from "./common/PeopleDesc";
import PeopleImage from "./common/PeopleImage";
import $ from "jquery";
import { textmapping } from "../helper";

const Home = (props) => {
  return (
    <>
      
      <Header />
      {/* <div className="">
        <div className="tiranga_header">
          <img src="assets/images/tiranga2.png" className="img-fluid" alt="" />
          <div className="trianga_div">
              <img
              src={
                props.lang == "gu"
                  ? "/assets/images/banner_gu.png"
                  : "/assets/images/banner_en.png"
              }
            />
          </div>
        </div>
      </div> */}

      <Effects page={"home"} lang={"en"} changeLang={props.changeLang} />
      {/* <PeopleDesc /> */}
      {/* <PeopleImage /> */}
      {/* <Footer /> */}
    </>
  );
};

export default Home;
